import { render } from "./PlanonethanksView.vue?vue&type=template&id=fcbfb234"
import script from "./PlanonethanksView.vue?vue&type=script&lang=js"
export * from "./PlanonethanksView.vue?vue&type=script&lang=js"

import "./PlanonethanksView.vue?vue&type=style&index=0&id=fcbfb234&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__